module.exports = __webpack_public_path__ + "img/bridge_loader.96a2096c.svg";